.banner {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  text-align: left;
  color: inherit;
  font: inherit;
  border-radius: var(--r-lg);
  border: 1px solid rgb(255 204 77 / 40%);
  background: linear-gradient(150deg, #2a2412 0%, #12100a 75%);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.banner:active {
  opacity: 0.85;
}

.wheel {
  position: relative;
  flex: none;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 3px solid #ffcc4d;
  background: conic-gradient(
    #ffcc4d 0 60deg,
    #2b2b2b 60deg 120deg,
    #f3f3f3 120deg 180deg,
    #2b2b2b 180deg 240deg,
    #ffcc4d 240deg 300deg,
    #8a3242 300deg 360deg
  );
  animation: turn 12s linear infinite;
}

.hub {
  position: absolute;
  inset: 34%;
  border-radius: 50%;
  background: #12100a;
  border: 2px solid #ffcc4d;
}

@keyframes turn {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .wheel {
    animation: none;
  }
}

.body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.title {
  font-size: 16px;
  font-weight: 700;
  color: #ffcc4d;
}

.text {
  font-size: 13px;
  color: var(--ink-soft);
}

.rule {
  font-size: 12px;
  color: var(--muted);
}
